/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useState } from 'react'
import moment from 'moment'
import {
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  ListItemText,
  Accordion,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { FaDownload, FaUpload } from 'react-icons/fa'
import Typography from '@material-ui/core/Typography'
import Spinner from '../../../Spinner'
import { EmailTransaction, Prospects as ProspectsStore } from '../../../../stores/prospects'
import CircleCheckbox from '../../../CircleCheckbox'

interface Props {
  // eslint-disable-next-line react/require-default-props
  prospects?: ProspectsStore
}
const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}))

const EmailTransactions: FC<Props> = ({ prospects }) => {
  const classes = useStyles()
  // const [isModalOpen, setisModalOpen] = useState(false)

  const [transactions, settransactions] = useState<EmailTransaction[] | undefined>([])
  const [isLoading, setisLoading] = useState<boolean>(false)

  const handleFetchTransactionHistory = async () => {
    if (transactions?.length === 0) {
      setisLoading(true)
      const response: EmailTransaction[] | undefined = await prospects?.getLeadTransactionHistory(
        prospects.prospect?.email,
      )
      settransactions(response)
      setisLoading(false)
    }
  }

  if (prospects?.prospect) {
    return (
      <div className="node-container">
        <Accordion className="email-history-accordion" onClick={handleFetchTransactionHistory}>
          <AccordionSummary
            expandIcon={
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
              <div>
                <ExpandMoreIcon style={{ color: '#fff' }} />
              </div>
            }
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <CircleCheckbox
              name="View Email Transactions"
              state
              titleClass="color-white"
              onChangeState={handleFetchTransactionHistory}
            />
          </AccordionSummary>
          <AccordionDetails>
            {isLoading ? (
              <Spinner />
            ) : (
              <List className={classes.root}>
                {transactions?.length ? (
                  transactions?.map(item => (
                    <ListItem key={1}>
                      {item.isReply ? (
                        <FaDownload className="mailIcon active-mailIcon" />
                      ) : (
                        <FaUpload className="mailIcon" />
                      )}
                      <ListItemText
                        className="transaction-title"
                        primary={item?.emailBodySnippet}
                        secondary={
                          <>
                            <Typography component="span" variant="body2" color="textPrimary">
                              {item?.maneuver}
                            </Typography>
                            <p>{moment(item?.transactionDate).format('MM/DD/YYYY')}</p>
                          </>
                        }
                      />
                    </ListItem>
                  ))
                ) : (
                  <ListItemText className="transaction-title" primary="No Emails Found" />
                )}
              </List>
            )}
          </AccordionDetails>
        </Accordion>
      </div>
    )
  }

  return null
}

export default EmailTransactions
